<template>
  <v-container>
    <v-row>
      <v-col cols="12" class="d-flex flex-wrap align-center">
        <div>
          <h1 class="title font-weight-light mb-lg-1">
            <v-icon class="mb-1" left>mdi-account-supervisor</v-icon>
            {{ $t("KULLANICILAR.HEADER.TITLE") }}
          </h1>
          <div class="pr-lg-15 mb-1"></div>
          <p class="text-caption font-weight-light mb-0">{{ $t("KULLANICILAR.HEADER.SUB_TITLE") }}</p>
        </div>
        <v-spacer />
        <div class="mt-2">
          <v-btn color="blue" class="text-overline" rounded dark @click="kullaniciEkleDialog = true">
            <v-icon left size="20">mdi-plus-circle</v-icon>
            {{ $t("KULLANICILAR.HEADER.ADD_NEW_USER_BTN") }}
          </v-btn>
        </div>
      </v-col>
      <v-col cols="12" lg="9" class="order-1 order-lg-0">
        <v-card class="mb-4">
          <v-data-table
            id="kullaniciListesi"
            :headers="headers"
            :items="kullaniciListesi"
            :no-data-text="noDataText"
            :server-items-length="kullaniciSayisi"
            @page-count="kullaniciPaginationLength = $event"
            :page.sync="kullanicilarPagination"
            :items-per-page="kullaniciListesPerPage"
            :loading="kullaniciListStatus"
            hide-default-footer
          >
            <template v-slot:[`item.id`]="{ item }">
              <strong>{{ item.id }}</strong>
            </template>
            <template v-slot:[`item.name`]="{ item }">
              <span class="font-weight-light">{{ item.name }}</span>
            </template>
            <template v-slot:[`item.email`]="{ item }">
              <a :href="`mailto:${item.email}`" class="blue--text" style="text-decoration:none">{{ item.email }}</a>
            </template>
            <template v-slot:[`item.publish`]="{ item }">
              <div v-if="item.publish === 1">
                <v-chip color="green" small class="white--text text-caption">{{ $t("KULLANICILAR.USER_STATUSES.APPROVED") }} </v-chip>
              </div>
              <div v-else-if="item.publish === 0">
                <v-chip color="orange" small class="white--text text-caption mr-2">
                  {{ $t("KULLANICILAR.USER_STATUSES.WAITING_APPROVE") }}
                </v-chip>
              </div>
              <div v-else-if="item.publish === 2">
                <v-chip color="black" small class="white--text text-caption mr-2">
                  {{ $t("KULLANICILAR.USER_STATUSES.FREEZED") }}
                </v-chip>
              </div>
            </template>
            <template v-slot:[`item.islemler`]="{ item }">
              <v-speed-dial id="kullaniciSpeedDial" v-model="kullaniciSpeedDial[item.id]" direction="left" :open-on-hover="false" transition="scale-transition" absolute>
                <template v-slot:activator>
                  <v-tooltip bottom color="blue darken-3">
                    <template v-slot:activator="{ on, attr }">
                      <v-btn v-on="on" v-bind="attr" x-small fab color="blue-grey lighten-4" depressed :loading="kullaniciIslemStatus[item.id]">
                        <v-icon color="blue">mdi-account-cog</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("KULLANICILAR.USER_ACTIONS.EDIT_USER") }}</span>
                  </v-tooltip>
                </template>
                <v-card class="px-1 d-flex" elevation="2" rounded="xl" color="blue-grey lighten-5">
                  <v-tooltip bottom color="blue darken-3">
                    <template v-slot:activator="{ on, attr }">
                      <v-btn v-on="on" v-bind="attr" x-small depressed class="blue darken-1 mr-2" fab dark @click="kullaniciDuzenle(item.id)">
                        <v-icon>mdi-account-edit</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("KULLANICILAR.USER_ACTIONS.EDIT_USER") }}</span>
                  </v-tooltip>
                  <v-tooltip bottom color="teal darken-3">
                    <template v-slot:activator="{ on, attr }">
                      <v-btn v-on="on" v-bind="attr" x-small depressed class="teal mr-2" fab dark @click="sifreDegistir(item.id)">
                        <v-icon>mdi-account-key</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("KULLANICILAR.USER_ACTIONS.CHANGE_PASSWORD") }}</span>
                  </v-tooltip>
                  <v-tooltip bottom color="blue-grey darken-3">
                    <template v-slot:activator="{ on, attr }">
                      <v-btn v-on="on" v-bind="attr" x-small depressed class="blue-grey mr-2" fab dark @click="sifreDegistir(item.id)">
                        <v-icon>mdi-basket</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("KULLANICILAR.USER_ACTIONS.ORDER_LIST") }}</span>
                  </v-tooltip>
                  <v-tooltip bottom color="cyan darken-4">
                    <template v-slot:activator="{ on, attr }">
                      <v-btn v-on="on" v-bind="attr" x-small depressed class="cyan darken-2 mr-2" fab dark @click="kullaniciDondur(item.id)">
                        <v-icon>mdi-map-marker</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("KULLANICILAR.USER_ACTIONS.VIEW_ADDRESSES") }}</span>
                  </v-tooltip>
                  <v-tooltip bottom color="orange darken-2">
                    <template v-slot:activator="{ on, attr }">
                      <v-btn v-show="item.publish === 0" v-on="on" v-bind="attr" x-small depressed class="orange mr-2" fab dark @click="kullaniciOnayla(item.id)">
                        <v-icon>mdi-account-check</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("KULLANICILAR.USER_ACTIONS.APPROVE_USER") }}</span>
                  </v-tooltip>
                  <v-tooltip bottom color="green">
                    <template v-slot:activator="{ on, attr }">
                      <v-btn v-show="item.publish === 2" v-on="on" v-bind="attr" x-small depressed class="green" fab dark @click="kullaniciAktiflestir(item.id)">
                        <v-icon>mdi-account-check</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("KULLANICILAR.USER_ACTIONS.ACTIVATE_USER") }}</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attr }">
                      <v-btn v-show="item.publish !== 2" v-on="on" v-bind="attr" x-small depressed class="black" fab dark @click="kullaniciDondur(item.id)">
                        <v-icon>mdi-account-remove</v-icon>
                      </v-btn>
                    </template>
                    <span>{{ $t("KULLANICILAR.USER_ACTIONS.FREEZE_USER") }}</span>
                  </v-tooltip>
                </v-card>
              </v-speed-dial>
            </template>
          </v-data-table>
        </v-card>
        <div id="kullanicilarPagination">
          <v-pagination v-model="kullanicilarPagination" :length="kullaniciPaginationLength" circle @input="pageClick"></v-pagination>
        </div>
      </v-col>
      <v-col cols="12" lg="3" class="order-0 order-lg-1">
        <div>
          <div class="text-h6 font-weight-light mb-3">
            <v-icon size="19" style="top:-2px" left>mdi-account-search</v-icon>
            {{ $t("KULLANICILAR.SEARCHBOX.TITLE") }}
            <v-divider />
          </div>
          <div>
            <v-text-field
              solo
              rounded
              prepend-inner-icon="mdi-magnify"
              clearable
              :label="$t('KULLANICILAR.SEARCHBOX.USER_LABEL')"
              v-model="kullaniciAraData.ara"
              hide-details
              @keyup.enter="kullaniciAra"
            >
              <template v-if="kullaniciAraData.ara" v-slot:append>
                <v-btn color="blue" fab dark x-small style="right:-5px" @click="kullaniciAra">
                  <v-icon>mdi-chevron-right</v-icon>
                </v-btn>
              </template>
            </v-text-field>
          </div>
        </div>
        <div class="mb-7">
          <v-row class="d-flex">
            <v-col class="d-flex justify-space-around align-center">
              <span class="text-body-2">{{ $t("KULLANICILAR.SEARCHBOX.CRITERIA_TEXT") }}:</span>
              <v-btn-toggle v-model="kullaniciAraData.araType" mandatory>
                <v-btn small class="text-caption text-capitalize" value="id">{{ $t("KULLANICILAR.SEARCHBOX.CRITERIA.ID") }} </v-btn>
                <v-btn small class="text-caption text-capitalize" value="name"> {{ $t("KULLANICILAR.SEARCHBOX.CRITERIA.NAME_SURNAME") }} </v-btn>
                <v-btn small class="text-caption text-capitalize" value="email"> {{ $t("KULLANICILAR.SEARCHBOX.CRITERIA.EMAIL") }} </v-btn>
              </v-btn-toggle>
            </v-col>
          </v-row>
        </div>
        <div>
          <div>
            <div class="text-h6 font-weight-light">
              <v-icon size="19" style="top:-2px" left>mdi-filter</v-icon>
              {{ $t("KULLANICILAR.FILTER.TITLE") }}
              <v-divider />
            </div>
            <div>
              <v-radio-group v-model="kullaniciFiltresi.durum" mandatory hide-details class="filtre-durum-group">
                <v-radio :value="2" selected color="grey darken-3" class="mb-4">
                  <template v-slot:label>
                    <span class="text-subtitle-2 grey--text text--darken-3">{{ $t("KULLANICILAR.FILTER.FILTERS.ALL") }}</span>
                  </template>
                </v-radio>
                <v-radio color="green darken-2" :value="1" class="mb-4">
                  <template v-slot:label>
                    <span class="text-subtitle-2 green--text text--darken-2">{{ $t("KULLANICILAR.FILTER.FILTERS.APPROVED") }}</span>
                  </template>
                </v-radio>
                <v-radio color="orange darken-4" :value="0" class="mb-4">
                  <template v-slot:label>
                    <span class="text-subtitle-2 orange--text text--darken-4">{{ $t("KULLANICILAR.FILTER.FILTERS.WAITING_APPROVE") }}</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>
            <v-divider />
            <div>
              <v-radio-group v-model="kullaniciFiltresi.siralama" mandatory hide-details class="filtre-durum-group">
                <v-radio value="desc" class="mb-4">
                  <template v-slot:label>
                    <span class="text-subtitle-2">{{ $t("KULLANICILAR.ORDERING.ORDER_METHODS.DESCENDING") }}</span>
                  </template>
                </v-radio>
                <v-radio value="asc" class="mb-4">
                  <template v-slot:label>
                    <span class="text-subtitle-2">{{ $t("KULLANICILAR.ORDERING.ORDER_METHODS.ASCENDING") }}</span>
                  </template>
                </v-radio>
              </v-radio-group>
            </div>
          </div>
        </div>
      </v-col>
      <kullanici-ekle @change="kullaniciEklendi" v-model="kullaniciEkleDialog" />
      <kullanici-duzenle v-model="kullaniciDuzenleDialog" />
      <sifre-degistir v-model="sifreDegistirDialog" :id="sifreDegistirKullaniciID" />
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from "vuex";
import KullaniciDuzenle from "../../../components/Modules/Kullanicilar/KullaniciDuzenle.vue";
import KullaniciEkle from "../../../components/Modules/Kullanicilar/KullaniciEkle.vue";
import SifreDegistir from "../../../components/Modules/Kullanicilar/SifreDegistir.vue";
import KullanicilarService from "@/services/KullanicilarService";

export default {
  components: { KullaniciEkle, KullaniciDuzenle, SifreDegistir },
  name: "KullaniciListesi",
  data() {
    return {
      headers: [
        { text: this.$t("KULLANICILAR.LIST.TABLE_FIELDS.ID"), value: "id", sortable: false },
        { text: this.$t("KULLANICILAR.LIST.TABLE_FIELDS.USER_NAME"), value: "name", sortable: false },
        { text: this.$t("KULLANICILAR.LIST.TABLE_FIELDS.EMAIL"), value: "email", sortable: false },
        { text: this.$t("KULLANICILAR.LIST.TABLE_FIELDS.STATUS"), value: "publish", sortable: false },
        { text: this.$t("KULLANICILAR.LIST.TABLE_FIELDS.ACTIONS"), value: "islemler", sortable: false }
      ],
      noDataText: this.$t("KULLANICILAR.LIST.NO_DATA_TEXT"),
      kullaniciSpeedDial: [],
      kullaniciEkleDialog: false,
      kullaniciDuzenleDialog: false,
      kullaniciIslemStatus: [],
      sifreDegistirDialog: false,
      sifreDegistirKullaniciID: "",
      kullaniciFiltresi: {
        durum: 2,
        siralama: 1
      },
      kullaniciAraData: {
        ara: "",
        sonuclar: [],
        araType: ""
      },
      kullanicilarPagination: 1,
      kullaniciPaginationLength: 0,
      toplamKullaniciSayisi: 0,
      kullaniciListesPerPage: 10,
      baslangic: 0,
      lastPage: 0,
      kullaniciListStatus: false
    };
  },
  methods: {
    kullaniciEklendi() {
      this.paginationSifirla();
      this.kullaniciListesiniGetir();
    },
    kullaniciOnayla(kullaniciID) {
      this.kullaniciIslemStatus[kullaniciID] = true;
      KullanicilarService.kullaniciOnayla(kullaniciID)
        .then(res => {
          if (res.status === 200) {
            const kullaniciDetay = res.data,
              kullaniciListesi = this.kullaniciListesi;
            /**
             * Son listeyi map'le
             */
            let yeniKullaniciListesi = kullaniciListesi.map(o => {
              if (o.id !== kullaniciDetay.id) {
                return o;
              } else return kullaniciDetay;
            });

            this.$store.commit("Kullanicilar/KullaniciList/setKullaniciListesi", yeniKullaniciListesi);

            this.$snotify.success(this.$t("KULLANICILAR.NOTIFY.USER_APPROVED_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
          } else this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        })
        .then(() => {
          this.$set(this.kullaniciIslemStatus, kullaniciID, false);
        });
    },
    kullaniciAktiflestir(kullaniciID) {
      this.kullaniciIslemStatus[kullaniciID] = true;
      KullanicilarService.kullaniciAktiflestir(kullaniciID)
        .then(res => {
          if (res.status === 200) {
            const kullaniciDetay = res.data,
              kullaniciListesi = this.kullaniciListesi;
            /**
             * Son listeyi map'le
             */
            let yeniKullaniciListesi = kullaniciListesi.map(o => {
              if (o.id !== kullaniciDetay.id) {
                return o;
              } else return kullaniciDetay;
            });

            this.$store.commit("Kullanicilar/KullaniciList/setKullaniciListesi", yeniKullaniciListesi);

            this.$snotify.success(this.$t("KULLANICILAR.NOTIFY.USER_ACTIVATE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
          } else this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        })
        .then(() => {
          this.$set(this.kullaniciIslemStatus, kullaniciID, false);
        });
    },
    kullaniciDondur(kullaniciID) {
      this.kullaniciIslemStatus[kullaniciID] = true;
      KullanicilarService.kullaniciDondur(kullaniciID)
        .then(res => {
          if (res.status === 200) {
            const kullaniciDetay = res.data,
              kullaniciListesi = this.kullaniciListesi;
            /**
             * Son listeyi map'le
             */
            let yeniKullaniciListesi = kullaniciListesi.map(o => {
              if (o.id !== kullaniciDetay.id) {
                return o;
              } else return kullaniciDetay;
            });

            this.$store.commit("Kullanicilar/KullaniciList/setKullaniciListesi", yeniKullaniciListesi);

            this.$snotify.success(this.$t("KULLANICILAR.NOTIFY.USER_FREEZE_SUCCESS"), this.$t("PANEL.NOTIFY.SUCCESS"));
          } else this.$snotify.error(res.data.errMessage, this.$t("PANEL.NOTIFY.ERROR"));
        })
        .then(() => {
          this.$set(this.kullaniciIslemStatus, kullaniciID, false);
        });
    },
    kullaniciDuzenle(kullaniciID) {
      this.kullaniciIslemStatus[kullaniciID] = true;
      this.$store
        .dispatch("Kullanicilar/KullaniciList/kullaniciDetay", kullaniciID)
        .then(res => {
          if (res.status === 200) this.kullaniciDuzenleDialog = true;
        })
        .then(() => {
          this.$set(this.kullaniciIslemStatus, kullaniciID, false);
        });
    },
    sifreDegistir(kullaniciID) {
      this.sifreDegistirDialog = true;
      this.sifreDegistirKullaniciID = kullaniciID;
    },
    kullaniciListesiniGetir() {
      /**
       * Kullanıcı listesini getir
       */
      this.kullaniciListStatus = true;
      const baslangic = this.baslangic,
        limit = this.kullaniciListesPerPage,
        durum = this.kullaniciFiltresi.durum,
        orderBy = this.kullaniciFiltresi.siralama;

      this.$store
        .dispatch("Kullanicilar/KullaniciList/kullaniciListesi", {
          baslangic,
          limit,
          durum,
          orderBy
        })
        .then(res => {
          this.kullaniciListStatus = false;

          /**
           * İsteğe bağlı olarak her dönen liste verisi için
           * ek düzenlemeler.
           */
          if (res.status === 200) {
            this.kullaniciListesi.forEach(el => {
              this.$set(this.kullaniciIslemStatus, el.id, false);
              this.$set(this.kullaniciSpeedDial, el.id, false);
            });
          }
        });
    },
    kullaniciAra() {
      const baslangic = this.baslangic,
        limit = this.kullaniciListesPerPage,
        ara = this.kullaniciAraData.ara,
        type = this.kullaniciAraData.araType;
      this.$store
        .dispatch("Kullanicilar/KullaniciList/kullaniciAra", {
          baslangic,
          limit,
          ara,
          type
        })
        .then(res => {
          if (res.status !== 200) this.$snotify.error(res.data);
        });
    },
    pageClick(page) {
      if (page !== this.lastPage) {
        /**
         * Başlangıç değerini pagination'a göre ayarla
         */
        this.baslangic = this.kullanicilarPagination * this.kullaniciListesPerPage - this.kullaniciListesPerPage;

        if (!this.kullaniciAraData.ara) {
          /**
           * Ürün listesini getir
           */
          this.kullaniciListesiniGetir();
        } else {
          /**
           * Ürünü aram sonucunu pagination'a göre getir
           */
          this.kullaniciAra();
        }
      }
    },
    paginationSifirla() {
      this.$store.commit("Kullanicilar/KullaniciList/setKullaniciListesi", []);
      this.$store.commit("Kullanicilar/KullaniciList/setKullaniciSayisi", 0);
      this.baslangic = 0;
      this.kullanicilarPagination = 1;
      return true;
    }
  },
  computed: {
    ...mapState({
      kullaniciListesi: state => state.Kullanicilar.KullaniciList.kullaniciListesi,
      kullaniciSayisi: state => state.Kullanicilar.KullaniciList.kullaniciSayisi
    })
  },
  watch: {
    /**
     * Sayfa değişiminde son geçilen sayfayı
     * bir değere at
     */
    kullanicilarPagination: {
      handler(page) {
        this.lastPage = page;
      },
      immediate: true
    },
    kullaniciFiltresi: {
      handler() {
        this.paginationSifirla();
        this.kullaniciListesiniGetir();
      },
      deep: true
    },
    "kullaniciAraData.ara"(val) {
      if (!val) {
        this.paginationSifirla();
        this.kullaniciListesiniGetir();
      }
    }
  }
};
</script>

<style>
@media screen and (max-width: 600px) {
  #kullaniciSpeedDial {
    position: relative;
  }
}
@media screen and (min-width: 600px) {
  #kullaniciSpeedDial {
    transform: translateY(-50%);
  }
}
</style>

<style lang="sass" scoped>
.v-application .filtre-durum-group .v-sheet
  border-width: 1px
  border-style: solid
  background-color: transparent !important
</style>
